import React, { memo } from 'react'
import { IEquipment } from 'types'
import { DISPLAY } from 'constants/display'
import { MARKETPLACE_EQUIPMENT_TYPES } from 'constants/equipment'

interface IEquipmentDetailsProps {
  equipment?: IEquipment
}

const formatEquipment = (equipment?: IEquipment) => {
  const { name, parentId } = equipment || {}
  if (!name || !parentId) return ''
  const equipmentSize = name.substring(0, name.indexOf(' '))
  const equipmentName = MARKETPLACE_EQUIPMENT_TYPES.find(e => e.id === parentId)?.name
  return `${equipmentSize} ${equipmentName}`
}

// TODO: Add temperature settings and equipment attributes
// The MP mapping for temperature settings and equipment attributes is making it tricky to achieve the designs
// Will revisit
export const MarketplaceEquipmentDetails = memo<IEquipmentDetailsProps>(({ equipment }) => {
  return (
    <span>
      <span>{formatEquipment(equipment) || DISPLAY.empty}</span>
    </span>
  )
})
